<template>
    <div class="d-flex">
        <v-app-bar
            fixed
            class="menu-mobile"
            height="45px"
        >
            <div class="d-flex align-center" style="width:100%">
                <div class="d-flex align-center">
                    <v-img
                        src="/imgs/logo_audycer_n.svg"
                        width="35px"
                        class="mr-2"
                    ></v-img>
                    <h1 class="text-menu-mobile mr-2">DEKATOO R&T</h1>
                    <h1 class="text-menu-mobile">ASOCIADOS SRL.</h1>
                </div>
                <v-spacer></v-spacer>
                <v-app-bar-nav-icon
                    style="color:black; width:35px; height:35px;"
                    @click="drawer=true"
                ></v-app-bar-nav-icon>
            </div>
        </v-app-bar>
        <v-navigation-drawer
            v-model="drawer"
            fixed
            temporary
            width="320"
            class="menu-mobile__list"
        >
            <v-toolbar>
                <div class="d-flex align-center">
                    <v-img
                        src="/imgs/logo_audycer_n.svg"
                        width="40px"
                        class="mr-2"
                    ></v-img>
                    <h1 class="text-menu-mobile mr-2">Audycer </h1>
                    <h1 class="text-menu-mobile">Asociados</h1>
                </div>
                <v-spacer></v-spacer>
                <v-icon @click="drawer=!drawer" color="black">
                    mdi-close-circle
                </v-icon>
            </v-toolbar>
            <v-list nav class="pb-0 pt-0 mt-2">
                <div
                    v-for="(option, index) in listMenu"
                    :key="index"
                >
                    <v-list-group
                        v-if="option.submenu.length>0"
                        :ripple="false"
                    >
                        <template v-slot:activator>
                            <v-list-item-icon class="mr-1">
                                <v-icon class="menu-mobile__option-icon" color="#ffffffe8">{{option.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>
                                <h1 class="text-menu">{{option.title}}</h1>
                            </v-list-item-title>
                        </template>
                        <v-list-item
                            v-for="(child, index) in option.submenu"
                            :key="index"
                            class="pl-4"
                            :to="child.route"
                            :ripple="false"
                            active-class="menu-mobile__option"
                        >
                            <v-list-item-title class="d-flex align-center">
                                <v-list-item-icon class="mr-2">
                                    <v-icon small color="#ffffffe8">
                                        mdi-arrow-right-bold
                                    </v-icon>
                                </v-list-item-icon>
                                <h1 class="text-menu">{{child.title}}</h1>
                            </v-list-item-title>
                        </v-list-item>
                    </v-list-group>
                    <v-list-item
                        v-else
                        :to="option.route"
                        :ripple="false"
                        active-class="menu-mobile__option"
                    >
                        <v-list-item-icon class="mr-1">
                            <v-icon class="menu-mobile__option-icon" color="#ffffffe8">{{option.icon}}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            <h1 class="text-menu">{{option.title}}</h1>
                        </v-list-item-title>
                    </v-list-item>
                </div>
                <v-list-item-group>
                    <v-list-item
                        class="mb-1"
                        :ripple="false"
                        @click="ac_closeSesion()"
                    >
                        <v-list-item-icon class="mr-2">
                            <v-icon class="menu-mobile__option-icon" color="#ffffffce">mdi-close</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>
                            <h1 class="text-menu">Cerrar Sesión</h1>
                        </v-list-item-title>
                    </v-list-item>
                </v-list-item-group>
            </v-list>
        </v-navigation-drawer>
        <OLoaderOperationComp
            :dialog="dialogSesion"
            smsLoaderOperation="Cerrando Sesión"
        />
    </div>
</template>
<script>
import { User } from '../../models'
import OLoaderOperationComp from '../../components/organisms/OLoaderOperationComp.vue'
export default {
    components: {
        OLoaderOperationComp
    },
    props: {
        listMenu: Array,
    },
    data: () => ({
        drawer: false,
        dialogSesion: false
    }),
    methods: {
        ac_closeSesion() {
            this.dialogSesion = true
            const apitoken = JSON.parse(localStorage.getItem('agapeconsultores')).token
            var header = {
                "Content-Type": "application/json",
                "Accept": "application/json",
                "Authorization": "Bearer " + apitoken,
            }
            User.logout(header).then(() => {
                localStorage.removeItem('agapeconsultores')
                this.dialogSesion = false
                setTimeout(() => {
                    this.$router.push('/login')
                }, 200)
            }).catch(error => {
                console.log(error)
                localStorage.removeItem('agapeconsultores')
                this.dialogSesion = false
                setTimeout(() => {
                    this.$router.push('/login')
                }, 200)
            })
        }
    }
}
</script>
